"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    {
        label: "产品规格型号",
        name: "chanpinguigexinghao",
    },
    {
        label: "产品组",
        name: "chanpinzu",
    },
    {
        label: "生产工单号",
        name: "shengchangongdanhao",
    },
    {
        label: "发货状态",
        name: "fahuozhuangtai",
        type: "select",
        options: [
            { label: "未发货", value: "未发货" },
            { label: "已发货", value: "已发货" },
        ],
    },
    {
        label: "销售订单号",
        name: "xiaoshoudingdanhao",
    },
    {
        label: "交货单号",
        name: "jiaohuodanhao",
    },
    {
        label: "发货通知单号",
        name: "fahuotongzhidanhao",
    },
    {
        label: "产品SN码",
        name: "chanpinsnma",
    },
];
